'use strict';

var App = require('app');

var Job = Backbone.Model.extend({
    defaults: {
        modelType: 'job',
    },

    initialize: function (options) {
        this.jobID = options.id;
        this.action = options.action;
        this.arguments = options.arguments;
    },

    url: function () {
        return '/api/v1/jobs' + (this.jobID ? '/' + this.jobID : '');
    },
});

var BackupJob = Job.extend({
    fetchProgress: function () {
        var def = $.Deferred();
        this.fetch({
            success: function (self, resp) {
                self.progress = resp.progress;

                def.resolve();
            },
            error: function () {
                def.reject();
            },
        });
        return def.promise();
    },
});

var API = {
    pollJob: function (id) {
        var defer = $.Deferred();
        var job = new Job({ jobID: id });
        job.fetch({
            success: function (data) {
                defer.resolve(data);
            },
            error: function (data) {
                defer.resolve(undefined);
            },
        });

        return defer.promise();
    },
};

App.reqres.setHandler('jobs:status', function (jobID) {
    return API.pollJob(jobID);
});

module.exports = {
    Job: Job,
    BackupJob: BackupJob,
};

// TODO: move BatchWriteRequest here!
